import { gql } from '@apollo/client';

export const fetchTermDetails = gql`
  query fetchTermDetails($id: ID!) {
    transactionAccount(id: $id) {
      id
      transactionAccountNumber
      availablePaymentMethods {
        totalCount
        nodes {
          id
          paymentIssue
          type
          default
          ... on CreditCard {
            card {
              expirationMonth
              expirationYear
              last4Numbers
              brand
              cardHolderName
            }
          }
          ... on PaymentOnTerms {
            terms {
              invoiceDueDays
            }
            totalCreditLimit
          }
          hasLinkedSubscriptions
        }
      }
      billToParty {
        name
        taxId
        addressLine1
        addressLine2
        city
        country
        postcode
        state
        taxExempt
        taxIds {
          id
          label
          displayName
          metadata {
            vatStatus
          }
          taxExempt
        }
        taxLabels {
          region
          taxIdLabels {
            type
            displayName
            description
            metadata {
              type
              labels {
                label
                vatStatus
                default
              }
            }
          }
        }
      }
      billingAccountsList {
        totalCount
        totalCreditLimit
        creditOutstanding
        availableCreditLimit
        paymentMethod
        currency
        status
        nodes {
          creditOutstanding
          status
          customerName
          transactionAccountNumber
        }
      }
    }
  }
`;
